import { Table } from '@mantine/core';

interface EmptyStateProps {
    message?: string;
}

const EmptyState = ({ message = 'No records to display' }: EmptyStateProps) => (
    <Table.Tr>
        <Table.Td className="py-20 text-center" colSpan={100}>
            {message}
        </Table.Td>
    </Table.Tr>
);

export default EmptyState;
